import getProductPrice from '../helpers/getProductPrice';
import productModel from './productModel';


const detailImpressionModel = function googleAnalyticsDetailImpression(product) {
  return {
    event: 'view_item',
    ecommerce: {
      currency: 'USD',
      value: getProductPrice(product),
      items: [
        { ...productModel(product) },
      ],
    },
  };
};

export default detailImpressionModel;
